import React from 'react';
import PageTop from '../../../core/components/PageTop';
import Panel from '../../../core/components/Panel';

// provider imports
import { useProviderListInit } from './pagehooks/useProviderListInit';
import ProviderListTable from './table/ProviderListTable';
import ProviderListSearch from './search/ProviderListSearch';

const PageAdminProviderList = (): JSX.Element => {
    // load page shell before pre-loading data
    return (
        <>
            <PageTop
                title="Provider List"
                icon="sprite-ops"
            />
            <div className="provider-feature provider-list">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    const init = useProviderListInit();

    if (!init) {
        return <></>;
    }

    return (
        <Panel flexDirection="column">
            <ProviderListSearch />
            <ProviderListTable />
        </Panel>
    );
};

export default PageAdminProviderList;
